import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  TableRow,
  TableCell,
  TextField,
  MenuItem
} from '@material-ui/core';

function CTableFilter (props) {

  function selectFilter (col) {
    const { filter = '', options = [], filterMinWidth = '', filterWidth = '' } = col;
    return (
      <TextField select style={{ minWidth: filterMinWidth, width: filterWidth }} value={filter} onChange={e => props.onFilterChange(e.target.value, col)}>
        {
          options.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))
        }
      </TextField>
    );
  }

  function textFilter (col) {
    const { filter = '', filterMinWidth = '', filterWidth = '', filterLabel = '' } = col;
    return (<TextField style={{ minWidth: filterMinWidth, width: filterWidth }} type='search' label={filterLabel} value={filter} onChange={e => props.onFilterChange(e.target.value, col)} />);
  }

  function filterEleBytype (col) {
    const { filterType } = col;
    if (filterType === 'select' || filterType === 'heartbeat') {
      return selectFilter(col);
    } else if (filterType === 'none') {
      return null;
    } else {
      return textFilter(col);
    }
  }
  return (
    <TableRow>
      {
        props.onRowSelect
          ? (<TableCell style={{ paddingBottom: 16 }}></TableCell>)
          : null
      }
      {
        props.colDef
          .filter(col => !col.hidden)
          .map((col, idx) => (
            <TableCell key={col.id || idx} style={{ paddingBottom: 16 }}>
              {filterEleBytype(col)}
            </TableCell>
          ))
      }
      {
        props.isExpandable
          ? (<TableCell style={{ paddingBottom: 16 }}></TableCell>)
          : null
      }
    </TableRow>
  );
}

CTableFilter.propTypes = {
  colDef: PropTypes.arrayOf(PropTypes.object).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  onRowSelect: PropTypes.func.isRequired,
  isExpandable: PropTypes.bool
};

export default memo(CTableFilter);
